import { TextField, IconButton } from '@mui/material'
import { ClearIcon } from '@mui/x-date-pickers'
import React, { useState } from 'react'

const MUIFieldWithoutControl: React.FC<any> = ({
  name,
  type,
  error,
  label,
  onChange,
  required = false,
  placeholder = '',
  value,
  inputProps,
  showClearIcon = false,
  disabled = false,
  ...props
}) => {
  const [showClear, setShowClear] = useState(false)

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setShowClear(true)}
      onMouseLeave={() => setShowClear(false)}
    >
      <TextField
        label={
          label && (
            <span>
              {label}
              {required && (
                <>
                  <span style={{ color: '#D4351C' }}>*</span>
                </>
              )}
            </span>
          )
        }
        id={name}
        data-testid={name ? name : label}
        placeholder={placeholder ?? label}
        variant='outlined'
        inputProps={{
          id: name,
          maxLength: props.maxLength,
          ...inputProps,
        }}
        fullWidth
        type={type}
        error={!!error?.[name]}
        helperText={error?.[name]?.message as string}
        value={value}
        onChange={(event: any) => onChange(event?.target.value)}
        disabled={disabled}
        autoComplete='off'
        {...props}
      />
      {value && value.length > 0 && showClearIcon && showClear && !disabled && (
        <IconButton
          data-testid='clear-field'
          size='small'
          onClick={() => {
            onChange('')
          }}
          sx={{
            position: 'absolute',
            right: '0.5rem',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <ClearIcon sx={{ height: '1rem', width: '1rem' }} />
        </IconButton>
      )}
    </div>
  )
}

export default MUIFieldWithoutControl
